var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-app', {
    style: [_vm.cssVars, {
      background: _vm.$vuetify.theme.themes['light'].background
    }]
  }, [_c('Navbar', {
    attrs: {
      "links": _vm.computedLinks,
      "isSmAndDown": _vm.isSmAndDown,
      "isXs": _vm.isXs
    },
    on: {
      "openPersonalCard": function openPersonalCard($event) {
        _vm.showPersonalCard = true;
      },
      "openInstructionsDialog": function openInstructionsDialog($event) {
        _vm.instructionsDialog = true;
      },
      "openHelpDialog": function openHelpDialog($event) {
        _vm.helpDialog = true;
      },
      "openContactsDialog": function openContactsDialog($event) {
        _vm.contactsDialog = true;
      }
    }
  }), !_vm.isSmAndDown && _vm.computedLinks.length ? _c('LeftMenu', {
    attrs: {
      "links": _vm.computedLinks
    }
  }) : _vm._e(), _c('PersonalData', {
    attrs: {
      "dialog": _vm.showPersonalCard
    },
    on: {
      "close": function close($event) {
        _vm.showPersonalCard = false;
      }
    }
  }), _c('Contacts', {
    attrs: {
      "dialog": _vm.contactsDialog
    },
    on: {
      "closeContactsDialog": function closeContactsDialog($event) {
        _vm.contactsDialog = false;
      }
    }
  }), _c('HelpDialog', {
    attrs: {
      "dialog": _vm.helpDialog
    },
    on: {
      "closeHelpDialog": function closeHelpDialog($event) {
        _vm.helpDialog = false;
      }
    }
  }), _c('v-main', {
    staticClass: "background main mr-3 ml-3",
    class: {
      'mobile': _vm.isSmAndDown
    }
  }, [_c('router-view', {
    attrs: {
      "isSmAndDown": _vm.isSmAndDown
    }
  })], 1), _c('v-footer', {
    staticClass: "background footer",
    attrs: {
      "padless": ""
    }
  }, [_c('v-col', {
    staticClass: "caption accent--text px-4",
    attrs: {
      "cols": "12"
    }
  }, [_vm._v(" © " + _vm._s(new Date().getFullYear()) + ", Заявления на восстановление и перевод ")])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }